import { Avatar, Box, Button, Chip, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from "@mui/material";
import { CloseRounded, GitHub, LaunchRounded, LinkedIn } from "@mui/icons-material";
import React from "react";

const ProjectDetails = ({ openModal, setOpenModal }) => {
  const project = openModal?.project;
  const handleClose = () => setOpenModal({ state: false, project: null });
  if (!project) return null;

  return (
    <Dialog open={Boolean(openModal?.state)} onClose={handleClose} maxWidth="md" fullWidth
      PaperProps={{
        className: "tactical-border",
        sx: { 
          bgcolor: "rgba(2, 4, 10, 0.95)", backdropFilter: "blur(10px)",
          border: "1px solid rgba(0, 240, 255, 0.3)", borderRadius: 0, m: 2
        }
      }}>
      
      {/* Top Bar */}
      <Box sx={{
        display: "flex", justifyContent: "space-between", alignItems: "center",
        borderBottom: "1px solid rgba(0, 240, 255, 0.2)", p: 2, bgcolor: "rgba(0, 240, 255, 0.05)"
      }}>
        <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", color: "#00f0ff", fontSize: "0.8rem", letterSpacing: "0.15em" }}>
          SYSTEM_ACCESS :: DECRYPTING_FILE
        </Typography>
        <IconButton onClick={handleClose} sx={{ color: "#00f0ff", p: 0.5 }}>
          <CloseRounded sx={{ fontSize: 18 }} />
        </IconButton>
      </Box>

      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", pt: 4 }}>
        <Stack spacing={1}>
          <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.6rem", color: "#6b7582", letterSpacing: "0.2em", transform: "rotate(-90deg)", position: "absolute", left: -10, top: 120 }}>
            CLASSIFIED
          </Typography>
          <Typography sx={{ fontFamily: "'Inter', sans-serif", fontWeight: 400, fontSize: "2rem", color: "#e6e8ec", lineHeight: 1 }}>
            {project.title}
          </Typography>
          {project.date && (
            <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#6b7582", letterSpacing: "0.1em" }}>
              [CREATED_ON: {project.date}]
            </Typography>
          )}
        </Stack>
      </DialogTitle>

      <DialogContent sx={{ pb: 4 }}>
        <Typography sx={{
          mt: 2, mb: 4, color: "#858d99", lineHeight: 1.8,
          fontSize: "0.95rem", fontFamily: "'Inter', sans-serif",
        }}>{project.description}</Typography>
        
        <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#00f0ff", letterSpacing: "0.1em", mb: 1 }}>
          + MODULES_DETECTED
        </Typography>
        <Stack direction="row" flexWrap="wrap" gap={1} mb={4}>
          {project.tags?.map((tag) => (
            <Chip key={tag} label={`> ${tag}`} size="small" sx={{
              bgcolor: "transparent", color: "#00f0ff",
              border: "1px dashed rgba(0, 240, 255, 0.3)", fontSize: "0.65rem",
              fontFamily: "'JetBrains Mono', monospace", borderRadius: 0
            }} />
          ))}
        </Stack>

        {project.member && (
          <Stack spacing={1.5} mb={4}>
            <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#00f0ff", letterSpacing: "0.1em" }}>
              + OPERATIVES
            </Typography>
            {project.member.map((p) => (
              <Stack direction="row" spacing={1.5} alignItems="center" key={p.name}>
                <Avatar src={p.img} variant="square" sx={{ width: 32, height: 32, border: "1px solid rgba(0, 240, 255, 0.2)", bgcolor: "transparent" }} />
                <Stack>
                  <Typography fontSize="0.85rem" fontWeight={500} color="#e6e8ec" fontFamily="'JetBrains Mono', monospace">{p.name}</Typography>
                  <Stack direction="row" spacing={0.5}>
                    {p.github && <IconButton size="small" href={p.github} target="_blank" sx={{ color: "#6b7582", p: 0.25, "&:hover": { color: "#00f0ff" } }}><GitHub sx={{ fontSize: 14 }} /></IconButton>}
                    {p.linkedin && <IconButton size="small" href={p.linkedin} target="_blank" sx={{ color: "#6b7582", p: 0.25, "&:hover": { color: "#00f0ff" } }}><LinkedIn sx={{ fontSize: 14 }} /></IconButton>}
                  </Stack>
                </Stack>
              </Stack>
            ))}
          </Stack>
        )}

        <Stack direction={{ xs: "column", sm: "row" }} spacing={2} mt={2} pt={4} borderTop="1px solid rgba(107, 117, 130, 0.2)">
          {project.github && (
            <Button variant="outlined" startIcon={<GitHub sx={{ fontSize: 16 }} />} href={project.github} target="_blank">
              INSPECT_SOURCE
            </Button>
          )}
          {project.webapp && (
            <Button variant="contained" startIcon={<LaunchRounded sx={{ fontSize: 16 }} />} href={project.webapp} target="_blank">
              LAUNCH_APPLICATION
            </Button>
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ProjectDetails;
